/**
 * Brand Health — logged-in merchant's brand, composed live from CT freightsnapshot.
 */
import React, {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {Box, Typography} from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import withLayout from '../../hocs/Layout'
import PageTitle from '../../common/PageTitle'
import Loader from '../../common/Loader'
import {useBrandHealth} from './useHealth'
import HealthMatrix from './HealthMatrix'
import VerticalToggle from './VerticalToggle'
import {LiveSnapshotNote} from '../../common/DashboardDateFilter'
import {FONT, SIZE, WEIGHT} from '../../styles/foundation/typography'
import {NAVY, BORDER, SUBTLE, WHITE} from '../../styles/foundation/colors'
import {SHADOW} from '../../styles/foundation/effects'
import {pageContainerSx} from '../../styles/patterns'

function EmptyHealth({msg}) {
  return (
    <Box sx={{bgcolor: WHITE, borderRadius: '12px', boxShadow: SHADOW.card, border: `1px solid ${BORDER}`, p: 5, textAlign: 'center'}}>
      <InfoOutlinedIcon sx={{fontSize: 40, color: BORDER, mb: 1}} />
      <Typography sx={{fontFamily: FONT, fontSize: SIZE.sm, fontWeight: WEIGHT.bold, color: NAVY}}>No critical-shipment data</Typography>
      <Typography sx={{fontFamily: FONT, fontSize: SIZE['2xs'], color: SUBTLE, mt: 0.5}}>{msg}</Typography>
    </Box>
  )
}

function BrandHealth() {
  const navigate = useNavigate()
  const [vertical, setVertical] = useState('B2C')
  const {data, loading, error} = useBrandHealth(vertical)

  return (
    <Box sx={pageContainerSx}>
      <PageTitle>Brand Health</PageTitle>

      <VerticalToggle value={vertical} onChange={setVertical} />

      <Box sx={{mb: 2.5}}>
        <LiveSnapshotNote message='Live view of your current pipeline — pending pickups, in-transit deliveries and RTO, plus completions today. It reflects the position of every shipment right now, so it is not filtered by a date range. Use “View” for date-ranged performance.' />
      </Box>

      {loading ? <Loader />
        : error ? <EmptyHealth msg='Could not load health data. Please try again.' />
          : (!data || data.totalCount === 0) ? <EmptyHealth msg='No shipments in the pickup, delivery or RTO pipeline for your brand right now.' />
            : <HealthMatrix entityHeader='Brand' entities={[data]} onView={() => navigate('/analytics')} />}
    </Box>
  )
}

export default withLayout(BrandHealth)
